export const ordersDefault = {
  orders: [],
  isProcessing: false,
  isQueried: false,
  isHexaOrderHistory: false,
}

const setOrders = (state, value) => {
  return { ...state, orders: value, isQueried: true }
}

const setIsProcessing = (state, value) => {
  return { ...state, isProcessing: value }
}

const setIsHexaOrderHistory = (state, value) => {
  return { ...state, isHexaOrderHistory: value }
}

const ordersActions = {
  ORDERS: setOrders,
  IS_PROCESSING: setIsProcessing,
  IS_HEXA_ORDERS_HISTORY: setIsHexaOrderHistory,
}

const ordersReducer = (state, action) => {
  return ordersActions[action.type](state, action.value)
}

export default ordersReducer
